module.exports = __webpack_public_path__ + "static/img/zhushihua.1210f832.jpg";